import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "../../lib/cn";

const badgeStyles = cva(
  "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium border",
  {
    variants: {
      tone: {
        neutral: "bg-bg-subtle text-fg-muted border-border-strong",
        accent: "bg-accent-soft text-accent-fg border-accent/30",
        success: "bg-success-soft text-success border-success/30",
        warning: "bg-warning-soft text-warning border-warning/30",
        danger: "bg-danger-soft text-danger border-danger/30",
      },
    },
    defaultVariants: {
      tone: "neutral",
    },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeStyles> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeStyles({ tone }), className)} {...props} />;
}
